import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-110" data-mp="20meizq13l45g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-111" data-mp="24nghu5r3re6w">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-success/25 bg-bg-primary p-8 sm:p-10" data-id="element-112" data-mp="24l3tnaur47le">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success/10" data-id="element-113" data-mp="2jajgifr5vsvt">
            <ShieldCheckIcon size={32} className="text-success" data-id="element-114" data-mp="2obpdwqvro4bo" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-bold uppercase leading-tight text-white sm:text-3xl" data-id="element-115" data-mp="2sbhmv4p2ochk">
            Garantía de 7 Días
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-116" data-mp="xyrpgczhwl5f">
            Si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo
            recibido no corresponde con la oferta mostrada en esta página, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-orange underline" data-id="element-117" data-mp="3ivn06lhur7xb">
              manualeslistos@gmail.com
            </a>{' '}
            y lo resolveremos.
          </p>
        </m.div>
      </div>
    </section>;
}